import { connect } from 'react-redux';

import AccountAppComponent from './account-app.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountAppComponent);



// WEBPACK FOOTER //
// ./src/components/account/app/account-app.ts